let ready;
const APP_ID = process.env.REACT_APP_ONESIGNAL_APP_ID;

export function pushEnabled() {
  return !!APP_ID;
}

export function oneSignal() {
  if (!APP_ID) return Promise.reject(new Error("OneSignal non configuré"));
  if (!ready) {
    ready = new Promise((resolve, reject) => {
      window.OneSignalDeferred = window.OneSignalDeferred || [];
      window.OneSignalDeferred.push(async (OneSignal) => {
        try {
          await OneSignal.init({
            appId: APP_ID,
            serviceWorkerPath: "push/onesignal/OneSignalSDKWorker.js",
            serviceWorkerParam: { scope: "/push/onesignal/" },
            allowLocalhostAsSecureOrigin: true,
            autoResubscribe: true,
          });
          resolve(OneSignal);
        } catch (e) {
          reject(e);
        }
      });
    });
  }
  return ready;
}

// A browser-permission grant is NOT enough: OneSignal must have a live,
// opted-in push subscription (id + token + optedIn) before login() can bind
// the external_id to a targetable device.
function subReady(s) {
  return !!(s && s.id && s.token && s.optedIn === true);
}

// Install the subscription-change observer and resolve once the subscription
// is actually registered server-side. Must be set up BEFORE optIn()/permission.
function waitForLiveSubscription(os, timeoutMs = 30000) {
  const push = os.User.PushSubscription;
  if (subReady({ id: push.id, token: push.token, optedIn: push.optedIn })) {
    return Promise.resolve(true);
  }
  return new Promise((resolve) => {
    let timer;
    const cleanup = () => {
      try { push.removeEventListener("change", onChange); } catch (e) { /* noop */ }
      clearTimeout(timer);
    };
    const onChange = (event) => {
      if (subReady(event.current)) { cleanup(); resolve(true); }
    };
    push.addEventListener("change", onChange);
    timer = setTimeout(() => { cleanup(); resolve(false); }, timeoutMs);
  });
}

// Re-associate on load: only login when a live subscription already exists.
export async function identifyPushUser(role, id) {
  if (!APP_ID || !role || !id) return;
  try {
    const os = await oneSignal();
    const push = os.User.PushSubscription;
    if (subReady({ id: push.id, token: push.token, optedIn: push.optedIn })) {
      await os.login(`${role}:${id}`);
    }
  } catch (e) {
    /* silent */
  }
}

// Full opt-in flow. Observer is registered first, then permission + optIn,
// then we wait for a real subscription, then bind the external_id.
export async function enablePush(role, id) {
  const os = await oneSignal();
  const live = waitForLiveSubscription(os); // listener installed before optIn
  if (!os.Notifications.permission) {
    await os.Notifications.requestPermission();
  }
  if (!os.Notifications.permission) {
    return false;
  }
  try { await os.User.PushSubscription.optIn(); } catch (e) { /* noop */ }
  await live;
  if (role && id) {
    try { await os.login(`${role}:${id}`); } catch (e) { /* noop */ }
  }
  return os.Notifications.permission;
}

export async function currentPermission() {
  if (!APP_ID) return false;
  try { const os = await oneSignal(); return !!os.Notifications.permission; } catch (e) { return false; }
}
